import { Link } from "react-router-dom";
import { ArrowUpRight, Mountain } from "lucide-react";
import { img } from "@/data/images";
import { ACCESS_LABEL } from "@/data/destinations";

const CAT_SHORT = { religious: "Sacred", hills: "Hill Station", lakes: "Lakes & Falls", wildlife: "Wildlife", adventure: "Trek & Adventure", heritage: "Heritage", itinerary: "Trip Plan" };

export default function DestinationCard({ d, testid }) {
  return (
    <Link
      to={`/destination/${d.slug}`}
      data-testid={testid || `destination-card-${d.slug}`}
      className="group relative flex flex-col overflow-hidden rounded-2xl border border-white/10 bg-coal card-lift"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={img(d.images[0], 800)}
          alt={`${d.name} — ${CAT_SHORT[d.category]} destination in Uttarakhand`}
          loading="lazy"
          className="img-zoom h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
        <div className="absolute left-3 top-3 flex flex-wrap gap-2">
          <span className="rounded-full bg-black/60 px-3 py-1 text-[11px] font-semibold tracking-wide text-gold backdrop-blur-md border border-gold/30">
            {CAT_SHORT[d.category]}
          </span>
          {d.category !== "itinerary" && d.access && d.access !== "road" && (
            <span className="rounded-full bg-black/60 px-3 py-1 text-[11px] font-medium text-white/90 backdrop-blur-md border border-white/15">
              {ACCESS_LABEL[d.access]}
            </span>
          )}
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-5">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-display text-xl font-semibold text-white">{d.name}</h3>
          <span className="mt-1 rounded-full border border-white/10 p-1.5 text-gold transition-all duration-300 group-hover:bg-gold group-hover:text-ink">
            <ArrowUpRight size={14} />
          </span>
        </div>
        <p className="line-clamp-2 text-sm leading-relaxed text-mist">{d.description}</p>
        <div className="mt-auto flex items-center gap-2 pt-3 text-[11px] font-medium uppercase tracking-wider text-slategray">
          <Mountain size={12} className="text-gold/70" />
          {d.region} · {d.base}
        </div>
      </div>
    </Link>
  );
}
